import { MemberHsaTransferType } from 'constants/hsaBulkTransfer';
import { gatewayClient } from 'utils/gatewayClient';

export interface FetchMemberHsaBulkTransferResponse {
  companyId: string;
  companyPlanId: string;
  createdAt: string;
  custodianName: string;
  employeeId: string;
  id: string;
  transferType: MemberHsaTransferType;
  updatedAt: string;
}

export function fetchHsaBulkTransferInfo() {
  return gatewayClient.get<FetchMemberHsaBulkTransferResponse>(
    `/pretax/accounts/hsa-transfer`
  );
}

export function recordHsaBulkTransferInfo({
  payload,
}: {
  payload: {
    custodianName: string;
    transferType: MemberHsaTransferType;
    transferDeadline?: string;
  };
}) {
  return gatewayClient.post(`/pretax/accounts/hsa-transfer`, payload);
}
